import { TopicMapping } from '../types/generator'

export const TOPIC_MAPPINGS: TopicMapping[] = [
  {
    topic: 'creation',
    keywords: ['creation', 'created', 'beginning', 'genesis', 'world', 'earth', 'heaven'],
    references: [
      'Genesis 1:1-2',
      'Genesis 1:26-27',
      'Genesis 2:7',
      'John 1:1-3',
      'Colossians 1:16',
      'Hebrews 11:3',
    ],
    description: 'The creation of the world and humanity',
  },
  {
    topic: 'love',
    keywords: ['love', 'loved', 'loving', 'beloved', 'charity'],
    references: [
      'John 3:16',
      '1 Corinthians 13:4-7',
      '1 John 4:7-8',
      'Romans 5:8',
      'Ephesians 5:25',
      '1 John 4:16',
    ],
    description: 'God\'s love and how we should love',
  },
  {
    topic: 'faith',
    keywords: ['faith', 'believe', 'believed', 'trust', 'trusted'],
    references: [
      'Hebrews 11:1',
      'Ephesians 2:8-9',
      'Romans 10:17',
      'James 2:14-26',
      'Mark 11:22-24',
      'Hebrews 11:6',
    ],
    description: 'What faith is and how to have faith',
  },
  {
    topic: 'salvation',
    keywords: ['salvation', 'saved', 'save', 'redeem', 'redemption', 'eternal life'],
    references: [
      'John 3:16',
      'Romans 10:9-10',
      'Ephesians 2:8-9',
      'Acts 16:31',
      'Titus 3:5',
      '1 Peter 1:3-5',
    ],
    description: 'How to be saved and receive eternal life',
  },
  {
    topic: 'prayer',
    keywords: ['prayer', 'pray', 'prayed', 'praying', 'petition', 'supplication'],
    references: [
      'Matthew 6:9-13',
      'Philippians 4:6-7',
      '1 Thessalonians 5:17',
      'James 5:16',
      'Matthew 7:7-8',
      'Luke 11:9-10',
    ],
    description: 'How to pray and the power of prayer',
  },
  {
    topic: 'forgiveness',
    keywords: ['forgive', 'forgiveness', 'forgiven', 'pardon', 'mercy'],
    references: [
      'Matthew 6:14-15',
      'Ephesians 4:32',
      'Colossians 3:13',
      '1 John 1:9',
      'Luke 6:37',
      'Matthew 18:21-22',
    ],
    description: 'Forgiving others and receiving forgiveness',
  },
  {
    topic: 'hope',
    keywords: ['hope', 'hoped', 'hoping', 'expectation', 'confident'],
    references: [
      'Romans 15:13',
      'Jeremiah 29:11',
      '1 Peter 1:3',
      'Hebrews 6:19',
      'Romans 8:24-25',
      'Psalm 42:11',
    ],
    description: 'Hope in God and His promises',
  },
  {
    topic: 'peace',
    keywords: ['peace', 'peaceful', 'tranquil', 'calm', 'serenity'],
    references: [
      'Philippians 4:7',
      'John 14:27',
      'Isaiah 26:3',
      'Romans 5:1',
      'Colossians 3:15',
      'Psalm 29:11',
    ],
    description: 'Finding peace in God',
  },
  {
    topic: 'wisdom',
    keywords: ['wisdom', 'wise', 'wisely', 'understanding', 'discernment'],
    references: [
      'Proverbs 1:7',
      'James 1:5',
      'Proverbs 3:5-6',
      'Proverbs 9:10',
      '1 Corinthians 1:25',
      'Proverbs 2:6',
    ],
    description: 'Seeking and applying wisdom',
  },
  {
    topic: 'strength',
    keywords: ['strength', 'strong', 'power', 'might', 'courage'],
    references: [
      'Philippians 4:13',
      'Isaiah 40:31',
      'Ephesians 6:10',
      '2 Corinthians 12:9-10',
      'Joshua 1:9',
      'Psalm 18:32',
    ],
    description: 'Finding strength in God',
  },
  {
    topic: 'grace',
    keywords: ['grace', 'gracious', 'favor', 'mercy', 'kindness'],
    references: [
      'Ephesians 2:8-9',
      '2 Corinthians 12:9',
      'Romans 3:23-24',
      'Titus 2:11',
      'John 1:16-17',
      'Romans 5:20-21',
    ],
    description: 'God\'s grace and unmerited favor',
  },
  {
    topic: 'obedience',
    keywords: ['obey', 'obedience', 'obedient', 'command', 'commandment'],
    references: [
      'John 14:15',
      '1 Samuel 15:22',
      'Deuteronomy 11:26-28',
      'Acts 5:29',
      'Romans 6:16',
      'Luke 11:28',
    ],
    description: 'The importance of obeying God',
  },
  {
    topic: 'repentance',
    keywords: ['repent', 'repentance', 'repented', 'turn', 'return'],
    references: [
      'Acts 3:19',
      'Luke 13:3',
      '2 Corinthians 7:10',
      'Acts 2:38',
      'Matthew 4:17',
      'Ezekiel 18:30-32',
    ],
    description: 'Turning away from sin and turning to God',
  },
  {
    topic: 'worship',
    keywords: ['worship', 'worshipped', 'praise', 'adore', 'glorify'],
    references: [
      'John 4:23-24',
      'Psalm 95:6',
      'Psalm 100:1-2',
      'Romans 12:1',
      'Hebrews 13:15',
      'Revelation 4:11',
    ],
    description: 'Worshipping God in spirit and truth',
  },
  {
    topic: 'serving',
    keywords: ['serve', 'serving', 'servant', 'service', 'minister'],
    references: [
      'Mark 10:45',
      'Galatians 5:13',
      '1 Peter 4:10',
      'Matthew 20:26-28',
      'Romans 12:11',
      'Colossians 3:23-24',
    ],
    description: 'Serving God and others',
  },
]

/**
 * Find topic mappings by keyword
 */
export function findTopicByKeyword(keyword: string): TopicMapping | undefined {
  const normalized = keyword.toLowerCase().trim()
  return TOPIC_MAPPINGS.find(
    mapping =>
      mapping.topic === normalized ||
      mapping.keywords.some(k => k.toLowerCase() === normalized || normalized.includes(k.toLowerCase()))
  )
}

/**
 * Get all available topics
 */
export function getAllTopics(): string[] {
  return TOPIC_MAPPINGS.map(m => m.topic)
}

